import React from "react";
import { Animate, Callout, CircularProgress } from "@sscs/ui";
import { LoginContentWrapper, LoginLayout } from "Components";
import EulaLink from "../../components/EulaLink/EulaLink";
import { useVerifyOIDC } from "../../hooks";

type WrapperProps = {
  children: React.ReactElement;
  animationKey: string;
};

const Wrapper = ({
  children,
  animationKey,
}: WrapperProps): React.JSX.Element => {
  return (
    <LoginLayout>
      <Animate.SimpleTransition animationKey={animationKey}>
        {children}
      </Animate.SimpleTransition>
    </LoginLayout>
  );
};

const VerifyOIDCLogin = (): React.JSX.Element => {
  const { verificationStatus } = useVerifyOIDC();

  if (verificationStatus === "status-unknown") {
    return (
      <Wrapper animationKey={verificationStatus}>
        <LoginContentWrapper title="Verifying authorization">
          <CircularProgress size="large" />
          <EulaLink />
        </LoginContentWrapper>
      </Wrapper>
    );
  } else if (verificationStatus === "status-error") {
    return (
      <Wrapper animationKey={verificationStatus}>
        <LoginContentWrapper title="Authorization failed">
          <Callout type="error" title="Contact your administrator">
            We were unable to confirm your authorization with the identity
            provider.
          </Callout>
          <EulaLink />
        </LoginContentWrapper>
      </Wrapper>
    );
  } else if (verificationStatus === "status-verified") {
    return (
      <Wrapper animationKey={verificationStatus}>
        <LoginContentWrapper title="Authorization verified">
          <Callout type="success" title="Signed in">
            Taking you to the application.
          </Callout>
          <EulaLink />
        </LoginContentWrapper>
      </Wrapper>
    );
  } else {
    return <></>;
  }
};

export default VerifyOIDCLogin;
